import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { Header } from "./components/header";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../common/components/legend_tag_item_component";
import { useMemo } from "react";
import { GenerateInspecaoItensPatrimonioCadastroColumnDefs } from "./columns";
import { GRID_CHECKBOX_SELECTION_FIELD, GridPinnedColumnFields } from "@mui/x-data-grid-pro";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { usePatrimonioItensInspecaoCadastroViewModel } from "../../viewModels/patrimonio_itens_inspecao_cadastro_view_model";
import { InspecaoPatrimonioModel } from "../../../domain/models/inspecao_patrimonio";
import { CustomStyledDataGrid } from "../PatrimonioCadastro_inspecao/components/custom_styled_data_grid";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { InspecaoPatrimonioModal } from "./components/inspecao_patrimonio_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import RefreshButton from "../../../../../common/components/refresh_button";

/**
 * ObraItensChecklistAreaCadastro
 */

export const PatrimonioItensInspecaoCadastro = () => {
  const viewModel = usePatrimonioItensInspecaoCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateInspecaoItensPatrimonioCadastroColumnDefs({
      statusChecklist: viewModel.statusChecklistServico,
      onActionEditar: viewModel.handleInspecaoPatrimonioOpenState,
      onActionDeletar: viewModel.handleInspecaoPatrimonioDeletar,
      onEnterInspecaoPatrimonio: viewModel.handleEnterInspecaoPatrimonio,
    });
  }, [
    viewModel.statusChecklistServico,
    viewModel.handleInspecaoPatrimonioOpenState,
    viewModel.handleInspecaoPatrimonioDeletar,
    viewModel.handleEnterInspecaoPatrimonio,
  ]);

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.inspecoesPatrimonio.length > 0 ?
      {
        left: [
          GRID_CHECKBOX_SELECTION_FIELD,
        ],
        right: [
          'idInspecaoPatrimonio',
        ],
      } : {
      };
  }, [
    viewModel.inspecoesPatrimonio,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[120px]">
                <PrimaryButton
                  onClick={() => viewModel.handleInspecaoPatrimonioOpenState(null, true)}
                  startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}>
                  Novo Item
                </PrimaryButton>
              </div>
              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Home
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/Patrimonio_maquinaEquip`}> Gestão de Maquina/Equipamento</LinkTo>
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/Patrimonio_cadastroInspecao?id=${viewModel.idPatrimonioCentroCusto}`}>Cadastro de Checklist</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Inspeções
          </Typography>
        </Breadcrumbs>
        {/**
          * ObrasTopHeader
          */}
        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white"> Inspeções</h1>
            <p>Pesquisar </p>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>
        </div>

        <div className="flex flex-row gap-8">
          <div className="flex flex-row text-black dark:text-white items-center">
            <span className="font-extrabold text-xl mr-2">Centro de Custo: </span>
            <span className="mx-1 font-base text-base">{viewModel.patrimonioChecklistInfo?.nomeCentroCusto ?? ''}  </span>
          </div>
          <div className="flex flex-row text-black dark:text-white items-center">
            <span className="font-extrabold text-xl mr-2">Checklist: </span>
            <span className="mx-1 font-base text-base">{viewModel.patrimonioChecklistInfo?.descricaoChecklist ?? ''}</span>
          </div>
        </div>

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                {/* {
                  viewModel.estatisticasChecklistServico &&
                  <StatisticsPanel
                    statusChecklistArea={viewModel.obraAreaChecklistHeader !== null ? viewModel.obraAreaChecklistHeader.status : null}
                    statusChecklistServico={viewModel.statusChecklistServico}
                    metaChecklistServico={viewModel.metaChecklistServico}
                    estatisticasChecklistServico={viewModel.estatisticasChecklistServico}
                    onChangeStatus={viewModel.handleChecklistServicoStatusChange}
                    onChangeMeta={viewModel.handleChecklistServicoMetaChange}
                    onBlurStatus={viewModel.handleSubmitMetaChecklistServico}
                  />
                } */}

                <Header
                  dataDe={viewModel.filters.dataDe}
                  dataAte={viewModel.filters.dataAte}
                  status={viewModel.filters.status}
                  onDataRangeChange={viewModel.handleDataRangeChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onClear={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-end">
                    <div className="flex flex-col flex-wrap">
                      <LegendComponent>
                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='VNI' bgColor="#facc15" />}
                          label='Verificação Não Iniciada' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='VI' bgColor="#3b82f6" />}
                          label='Verificação Iniciada' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='E' bgColor="#009c4e" />}
                          label='Encerrada' />

                      </LegendComponent>
                    </div>
                  </div>

                  <CustomStyledDataGrid
                    tableName="obra_itens_checklist_area_cadastro"
                    disableColumnMenu={false}
                    getRowId={(row: InspecaoPatrimonioModel) => row.idInspecaoPatrimonio}
                    getRowHeight={() => 'auto'}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.inspecoesPatrimonio}
                    rowCount={viewModel.inspecoesPatrimonio.length}
                    checkboxSelection={true}
                    textSize="pequeno"
                    pinnedColumns={pinnedColumns}
                    disableRowSelectionOnClick={true}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    isRowSelectable={x => x.row.status === 1/* Encerrada */}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                    disableColumnSorting={false}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }
      </div>

      {/**
        * BottomBar
        */}

      <BottomBar>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div>
          </div>

          <div className="flex flex-row gap-4">
            {
              (viewModel.statusChecklistServico === 0) &&
              <div className="w-[200px]">
                <PrimaryButton
                  buttonColor="secondary"
                  onClick={() => { }}
                  startIcon={<DynamicIcon nameIcon="Check" size={25} className="text-[#009C4E]" />}>
                  Aprovar Selecionados
                </PrimaryButton>
              </div>
            }
          </div>
        </div>
      </BottomBar>

      {/**
        * Modals
        */}

      <InspecaoPatrimonioModal
        open={viewModel.inspecaoPatrimonioModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectecInspecaoPatrimonio={viewModel.selectedInspecaoPatrimonio}
        onClose={() => viewModel.handleInspecaoPatrimonioOpenState(null, false)}
        onSubmit={viewModel.handleInspecaoPatrimonioSubmit}
      />

      {/* <InspecaoPatrimonioAprovacaoModal
        open={viewModel.inspecaoPatrimonioAprovacaoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionarioInformation={viewModel.funcionarioInformation}
        onClose={() => viewModel.handleInspecaoPatrimonioAprovacaoOpenState(false)}
        onSubmit={viewModel.handleInspecaoPatrimonioAprovacaoSubmit}
      /> */}

      {/* <InspecaoPatrimonioCopyModal
        open={viewModel.inspecaoPatrimonioCopyModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={viewModel.handleInspecaoPatrimonioCopy}
        onSubmit={viewModel.handleInspecaoPatrimonioCopyConfirm}
      /> */}

      <DeleteDialog
        open={viewModel.inspecaoPatrimonioDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleInspecaoPatrimonioDeletar(null, false)}
        onDelete={() => viewModel.handleInspecaoPatrimonioDeletarConfirm()}
      />

      {/**
        * Relatorios obras.
        */}


      {/* <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      /> */}

    </>
  );
}